import { render, staticRenderFns } from "./AddressEntryRequestForm.vue?vue&type=template&id=5870640c&"
import script from "./AddressEntryRequestForm.vue?vue&type=script&lang=js&"
export * from "./AddressEntryRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports